import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=542b8f80&scoped=true&"
import script from "./Billing.vue?vue&type=script&lang=ts&"
export * from "./Billing.vue?vue&type=script&lang=ts&"
import style0 from "./Billing.vue?vue&type=style&index=0&id=542b8f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b8f80",
  null
  
)

export default component.exports